/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SearchDetail.vue?vue&type=template&id=3ca2acba&scoped=true&lang=html&"
import script from "./SearchDetail.vue?vue&type=script&lang=js&"
export * from "./SearchDetail.vue?vue&type=script&lang=js&"
import style0 from "./SearchDetail.vue?vue&type=style&index=0&id=3ca2acba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca2acba",
  null
  
)

export default component.exports